@if (data) {
  <object class="pdf-container" [attr.data]="data" type="application/pdf">
  </object>
}
